import * as Yup from 'yup';
import { QuestionBundleValidator } from '../../types/QuestionSettings';

const regexPath = /^(\/|\/[\w+\-][\/[\w+\-\.\!\$\&\'\(\)\,\;\=\:\@\~\*]*]*)(\?.*)?$/i;

export const ScheduleGenieFormValidationSchema = () =>
    Yup.object({
        call_to_action: Yup.string()
            .max(40)
            .required('Please enter a call to action.'),
        slot_length: Yup.number().min(0),
        pathnames: Yup.array()
            .nullable()
            .of(
                Yup.string()
                    .nullable()
                    .matches(
                        regexPath,
                        `Must be a valid URL path string. (Paths must start with "/", may not contain spaces, and may only include alphanumeric characters and some specific special characters.)`
                    )
            ),
        path_rule_type: Yup.string()
            .oneOf(['include', 'exclude'], 'Path rule type must be either "include" or "exclude"')
            .default('include'),
        question_bundle: QuestionBundleValidator
    });
